// Which Manage Groups layout a teacher gets, from the warm_up_challenges flag
// status ({ enabled, isLoading } from useFeatureFlagStatus):
//   "pending"  the answer has not arrived: the Class row and a skeleton only;
//   "one_list" the flag is on: every group of the class as one sorted list;
//   "sections" the flag is off or its request failed: today's page.
// Both lesson-flow and CCSS views read their layout here and nowhere else.
export const manageGroupsLayoutFor = ({ enabled, isLoading }) => {
  if (isLoading) return "pending";
  return enabled ? "one_list" : "sections";
};
